import { render } from "./SelectSearch.vue?vue&type=template&id=ab6ae466&scoped=true"
import script from "./SelectSearch.vue?vue&type=script&lang=js"
export * from "./SelectSearch.vue?vue&type=script&lang=js"

import "./SelectSearch.vue?vue&type=style&index=0&id=ab6ae466&lang=scss&scoped=true"

import exportComponent from "/home/nodeapps/vitamins/aaa/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab6ae466"]])

export default __exports__